import { Component } from '@angular/core';

@Component({
  selector: 'mav-map-of-science-icon',
  templateUrl: './map-of-science-icon.component.html',
  styleUrls: ['./map-of-science-icon.component.scss']
})
export class MapOfScienceIconComponent {

  constructor() { }
}
